import { render, staticRenderFns } from "./SYTradeDetail.vue?vue&type=template&id=f6510086&"
import script from "./SYTradeDetail.vue?vue&type=script&lang=js&"
export * from "./SYTradeDetail.vue?vue&type=script&lang=js&"
import style0 from "./SYTradeDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports